module.exports = __webpack_public_path__ + "static/media/squares-four.b384bb6e.svg";